import { render, staticRenderFns } from "./NfsePrefeituraCreateUpdate.vue?vue&type=template&id=1dcc1dff&scoped=true&"
import script from "./NfsePrefeituraCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./NfsePrefeituraCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./NfsePrefeituraCreateUpdate.vue?vue&type=style&index=0&id=1dcc1dff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcc1dff",
  null
  
)

export default component.exports